import React from "react";

const StatsTab = ({ umpire }) => (
  <div className="max-w-3xl mx-auto">
    <h2 className="text-xl font-bold mb-4 text-green-800">Experience & DRS</h2>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
      <div>
        <div className="text-gray-500 text-xs">Test Matches</div>
        <div className="font-bold">{umpire.matchesTest ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">ODI Matches</div>
        <div className="font-bold">{umpire.matchesOdi ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">T20I Matches</div>
        <div className="font-bold">{umpire.matchesT20i ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">First-Class</div>
        <div className="font-bold">{umpire.matchesFirstClass ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">List A</div>
        <div className="font-bold">{umpire.matchesListA ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">T20 Domestic</div>
        <div className="font-bold">{umpire.matchesT20Domestic ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">DRS Decisions Made</div>
        <div className="font-bold">{umpire.drsDecisionsMade ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">DRS Upheld</div>
        <div className="font-bold">{umpire.drsDecisionsUpheld ?? '—'}</div>
      </div>
      <div>
        <div className="text-gray-500 text-xs">DRS Accuracy (%)</div>
        <div className="font-bold">{umpire.drsAccuracyPercent ?? '—'}</div>
      </div>
    </div>
  </div>
);

export default StatsTab; 